import React, { useState, useEffect } from "react";

import galleryImg from "assets/images-panel/gallery.png";
import { useGallery } from "store/gallery";

function GalleryFieldUrl(props) {
  const { field, form } = props;
  const [preview, setPreview] = useState("");
  const { toggleGallery, dispatch, getItem } = useGallery();
  useEffect(() => {
    if (props.preview) {
      setPreview(props.preview);
    } else if (props.dataType == "id") {
      dispatch(
        getItem(field.value, (data) => {
          setPreview(data.url);
        })
      );
    }
  }, [props.preview, field.value]);

  return (
    <div>
      <label
        className="block uppercase text-gray-700 text-xs font-bold my-2"
        htmlFor="grid-password"
      >
        {props.label}
      </label>
      <div
        className="flex border-dashed border-2 rounded cursor-pointer w-full justify-center items-center h-10"
        onClick={() => {
          dispatch(
            toggleGallery((file) => {
              setPreview(file.url);
              form.setFieldValue(
                field.name,
                props.dataType === "url" ? file.url : file.id
              );
              dispatch(toggleGallery());
              navigator.clipboard.writeText(file.url);
            })
          );
        }}
      >
        {field.value && field.value != " " ? "ادرس کپی شد!" : ""}
      </div>
    </div>
  );
}

export default GalleryFieldUrl;
